(function ($) {

    var gdprFormDescriptor = "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";

    $(".submit-button").attr("disabled", "disabled");

    GetFormDescriptor();

    function GetFormDescriptor() {
        $.ajax({
            async: true,
            type: "GET",
            beforeSend: function (request) {
                request.setRequestHeader("X-LID", $("#lid").val());
            },
            url: gdprFormDescriptor,
            success: function (resp) {
                if (resp != null) {
                    $("#gdpr").val(JSON.stringify(resp));
                    GenerateFields(resp);
                    $(".submit-button").removeAttr("disabled");
                }
            },
            error: function (resp) {
                console.log(resp)

            }

        });
    }

    function GenerateFields(x) {
        $.each(x, function (key, val) {
            if (key === "policies") {
                $.each(val, function (index, value) {
                    if (value.type === "checkbox") {
                        GenerateChecbox(value)
                    }

                    if (value.type === "radio") {
                        GenerateRadio(value)
                    }

                });
            }


        });


    }

    function GenerateChecbox(policy) {
        var html =
            '<div class="checkbox">' +
            '<input type="checkbox" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" ' + (policy.required ? "required" : "") + ' />' +
            '<label class="gdpr-policy-label">' + policy.description + '</label>' +
            '</div>' +
            '</div>';

        var old = $("#gdpr-block").html();
        $("#gdpr-block").html(old + html);

    }

    function GenerateRadio(policy) {
        var html = ' <div class="form-group radioButtons"> ' +
            '<div class="gdpr-scrollable">' +
            policy.title + "<br />" + policy.description +
            '<br />' +
            '</div>' +
            '<label class="radio-inline">' +
            '<input type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" required /> <span>' + policy.accept_label + '</span>' +
            '</label>' +
            '<label class="radio-inline">' +
            '<input type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="0" /> <span>' + policy.deny_label + '</span>' +
            '</label>' +
            '</div>'

        var old = $("#gdpr-block").html();
        $("#gdpr-block").html(old + html);
    }

})(jQuery);